import { FC } from 'react'
import classNames from 'classnames'
import classes from './index.module.css'
import { LeadStatus } from '@/api/types/crm/crm.types'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { DeleteOutlined } from '@ant-design/icons'
import { formatCrmDateMsk, formatCrmTimeMsk } from '../../../../utils/formatData'

interface StatusItemProps {
  leadStatus: LeadStatus
  onDelete?: (leadStatus: LeadStatus) => void
  showDeleteButton?: boolean
  isCurrentStatus?: boolean
  size?: 'default' | 'large'
}

const StatusItem: FC<StatusItemProps> = ({
  leadStatus,
  onDelete,
  showDeleteButton = false,
  isCurrentStatus = false,
  size = 'default',
}) => {
  return (
    <div
      className={classNames(classes.statusListItem, {
        [classes.statusListItemLarge]: size === 'large',
      })}
    >
      <div className={classes.statusListItemDate}>
        <span className={classes.bold}>
          {formatCrmDateMsk(leadStatus.created_at)}
        </span>
        <span>{formatCrmTimeMsk(leadStatus.created_at)}</span>
      </div>
      <div className={classes.statusListItemContent}>
        <span
          className={classes.statusListItemColor}
          style={{ backgroundColor: leadStatus.status.color }}
        />
        <span className={classes.statusListItemName}>
          {leadStatus.status.name}
        </span>
      </div>
      {showDeleteButton ? (
        <TooltipWrapper
          title={
            isCurrentStatus
              ? 'Это текущий статус, его нельзя удалить'
              : 'Удалить из истории'
          }
        >
          <span className={classes.deleteButtonWrap}>
            <button
              type="button"
              className={classes.deleteButton}
              aria-label={
                isCurrentStatus
                  ? 'Текущий статус нельзя удалить'
                  : 'Удалить статус из истории'
              }
              disabled={isCurrentStatus}
              onClick={() => onDelete?.(leadStatus)}
            >
              <DeleteOutlined
                className={classes.deleteIcon}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            </button>
          </span>
        </TooltipWrapper>
      ) : null}
    </div>
  )
}

export default StatusItem
